import { ReactNode } from "react";

import "./Tooltip.scss";

interface Props {
  text: ReactNode;
  children: ReactNode;
  display?: boolean;
  position?: "top" | "middle" | "bottom";
  className?: string;
}

export const Tooltip = ({
  text,
  children,
  display = true,
  position = "top",
  className = "",
}: Props) => (
  <>
    {display ? (
      <div className={`tooltip ${className}`}>
        {children}
        <div
          className={`tooltiptext ${
            position === "top" ? "tooltiptext-top" : ""
          } ${position === "middle" ? "tooltiptext-middle" : ""} ${
            position === "bottom" ? "tooltiptext-bottom" : ""
          }`}
        >
          {text}
        </div>
      </div>
    ) : (
      <>{children}</>
    )}
  </>
);
